import { Routes } from '@angular/router';
import { MyBillsPageComponent } from './my-bills-page.component';
import { MyBillsPaymentPageComponent } from './containers/my-bills-payment-page/my-bills-payment-page.component';
import { AuthGuard } from '../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../guards/is-completed-user-data.guard';
import {
  MyBillsPaymentDetailsPageComponent
} from './containers/my-bills-payment-details-page/my-bills-payment-details-page.component';
import {
  MyBillsPaymentStatusPageComponent
} from './containers/my-bills-payment-status-page/my-bills-payment-status-page.component';
import { MyBillsPayComponent } from './containers/my-bills-pay.component';
import {
  MyBillsPayStatusComponent
} from './containers/my-bills-pay-status.component';

export const myBillsRoutes: Routes = [
  {
    component: MyBillsPageComponent,
    path: 'moje-oplaty'
  },
  {
    component: MyBillsPaymentStatusPageComponent,
    path: 'moje-oplaty/status-platnosci/:identSigId/:serviceCode',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: MyBillsPaymentStatusPageComponent,
    path: 'moje-oplaty/status-platnosci/:identSigId/:serviceCode/:idZap',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: MyBillsPayStatusComponent,
    path: 'moje-oplaty/zaplac/status'
  },
  {
    component: MyBillsPayComponent,
    path: 'moje-oplaty/zaplac/:identSigId/:serviceCode',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: MyBillsPayComponent,
    path: 'moje-oplaty/zaplac/:identSigId/:serviceCode/:idZap',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: MyBillsPaymentPageComponent,
    path: 'moje-oplaty/:identSigId/:serviceCode',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: MyBillsPaymentDetailsPageComponent,
    path: 'moje-oplaty/:identSigId/:serviceCode/:idZap',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
